import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@spartacus/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription, take } from 'rxjs';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { ComponentService } from 'src/app/service/component.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-cart-delete',
  templateUrl: './cart-delete.component.html',
  styleUrls: ['./cart-delete.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon, TranslatePipe],
})
export class CartDeleteComponent implements OnInit, OnDestroy {
  @Input()
  cartId: string;
  showSrp = false;
  srpSubscription$: Subscription;
  constructor(
    protected modalService: StandardModalService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    public deviceDetectorService?: DeviceDetectorService
  ) {}

  ngOnInit() {
    this.getInitSrpToggleValue();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      this.cdr.detectChanges();
    });
  }

  deleteCartModal(): void {
    this.modalService
      .openDialog(CUSTOM_LAUNCH_CALLER.DELETE_CART, this.el, this.vcr, { cartId: this.cartId })
      ?.pipe(take(1))
      .subscribe();
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  ngOnDestroy() {
    if (this.srpSubscription$) {
      this.srpSubscription$.unsubscribe();
    }
  }
}
